import Splide from '@splidejs/splide';
import copyToClipboard from '../components/copy-to-clipboard-func'
import '../../styles/pages/tv-host.scss';
import generateTabs from '../components/generateTabs';

generateTabs('sidebar-last', { isLoadMore: false });
document.querySelector('.sidebar-last .load-more').addEventListener('click', function (e) {
  let active_tab = e.target.closest('.sidebar-last').querySelector('.tabs__item_active').dataset.tab || 'all';
  let tab_content = e.target.closest('.sidebar-last').querySelector(`[data-tabdata=${active_tab}]`);
  load_posts('/load-posts/', tab_content, 'list', tab_content.dataset.page, active_tab);
});


new Splide('.tv-host-slider', {
  type: 'loop',
  autoWidth: true,
  perMove: 1,
  pagination: false,
  flickPower: 100,
  arrows: true,
  focus: 'center',
  gap: 32,
  breakpoints: {
    1024: {
      gap: 16,
    },
  }
}).mount()

// copy to clipboard
const shareBtns = document.querySelectorAll('.share-button');
shareBtns.forEach((itm) => {
  itm.addEventListener('click', async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          url: window.location.href
        });
      } else {
        const img = itm.querySelector('img');
        if (!img) return;
        await copyToClipboard(window.location.href);
        img.src = '/static/news/img/base/check_mark.png';

        setTimeout(() => {
          img.src = '/static/news/img/base/share-gray.svg';
        }, 2000)
      }
    } catch (err) {
      console.log(err)
    }
  })
})

const readMoreSlide = document.querySelector('.read-more-slider-placeholder');
if (readMoreSlide) {
  new Splide(readMoreSlide, {
    type: 'loop',
    gap: 24,
    pagination: false,
    arrows: true,
    autoWidth: true,
    breakpoints: {
      768: {
        arrows: false,
      }
    }
  }).mount();
}

// share-gray.svg